import { NgIf } from '@angular/common'
import { Component, Input } from '@angular/core'
import { RouterLink } from '@angular/router'

import { WorkingGroup } from '../../../interfaces/resources/working-group.interface'

@Component({
  selector: 'app-working-group-card',
  templateUrl: './working-group-card.component.html',
  styleUrls: ['./working-group-card.component.scss'],
  standalone: true,
  imports: [RouterLink, NgIf]
})
export class WorkingGroupCardComponent {
  @Input() workingGroup: WorkingGroup
}
